// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ProductCarouselWidget, {
    OwnProps as ProductCarouselProps,
} from "@hardwoods/Overrides/Widgets/Common/ProductCarousel";
import { xIsAuthenticated } from "@hardwoods/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC } from "react";

interface OwnProps extends ProductCarouselProps {}

const FeaturedProducts: FC<OwnProps> = ({ fields }) => {
    const session = useAppSelector(state => getSession(state));
    if (!xIsAuthenticated(session)) {
        return null;
    }

    return (
        <>
            {createWidgetElement("Common/ProductCarousel", {
                fields: { ...fields, carouselType: "featuredProducts" },
            })}
        </>
    );
};

const excludeFieldDefinitions = ["carouselType", "displayProductsFrom", "selectedCategoryIds", "relatedProductType"];
const fieldDefinitions =
    ProductCarouselWidget.definition.fieldDefinitions?.filter(
        fieldDefinition => !excludeFieldDefinitions.includes(fieldDefinition.name),
    ) ?? [];

const widgetModule: WidgetModule<FieldDefinition> = {
    component: FeaturedProducts,
    definition: {
        group: "Xngage Custom" as any,
        displayName: "Featured Products",
        fieldDefinitions: [...fieldDefinitions],
    },
};

export default widgetModule;
